import { APP_INITIALIZER, Provider } from '@angular/core';
import {TenantContextService} from "./services/tenantcontext.service";
import {environmentReady} from "./environment.ready";

export function initTenantFactory(service: TenantContextService) {
  return async () => {
    await environmentReady;      // 👈 wartet bis initApp fertig ist
    return service.init();       // erst jetzt wird Tenant geladen
  }; // async init-Methode
}

export const TenantInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initTenantFactory,
  deps: [TenantContextService],
  multi: true
};
